import React from 'react';
import {connect} from 'react-redux';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import PlayerExclusionSwitcher from 'components/molecules/player-exclusion/player-exclusion-switcher';
import TeamLogo from 'components/molecules/team-logo';
import FilterLineupsByPlayerAndFlex from 'components/molecules/filter-lineups-by-player/filter-lineups-by-player-and-flex';
import LockedPlayerGameMarker from 'components/molecules/locked-player-game-marker';
import PlayerInjury from 'components/molecules/player-injury';
import {getPlayerLineupsQuantityPropName} from 'components/organisms/used-players-list/helpers';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;
        const filteredPlayers = this.getFilteredUsedPlayers();

        let searchParams = {
            ...this.getSearchRuleByPosition(),
        };

        if (filters.position.isKeyFlex() && !filters.isShowUnexposedPlayersEnabled()) {
            searchParams = {
                ...searchParams,
                ...this.getSearchRuleByFlexPosition(),
            };
        }

        const players = filterObjectByParams(filteredPlayers, searchParams, true);
        const sortBy = getPlayerLineupsQuantityPropName(filters.position);

        return sortArrayOfObjects(players, sortBy, 'desc');
    }

    render() {
        const {filters} = this.props;
        const players = this.getPlayers();
        const renderKey = this.getRenderKey();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tr key={`${renderKey}${index}`} className={`${className} ${this.getRowClassName(player)}`}>
                        <td className="check">
                            <PlayerExclusionSwitcher playerId={player.getId()} />
                        </td>
                        <td>
                            <FilterLineupsByPlayerAndFlex player={player} filterPosition={filters.position} />
                        </td>
                        <td>
                            <LockedPlayerGameMarker player={player} />
                        </td>
                        <td className="name">
                            {player.name}
                            <PlayerInjury player={player} />
                        </td>
                        <td>{player.positionName}</td>
                        <td className="td-team">
                            <TeamLogo teamName={player.team} />
                        </td>
                        <td>
                            {this.wrapContentInTooltip(
                                <PlayerPoints
                                    className="form-control xs-table-input"
                                    playerId={player.getId()}
                                    propName={'userPoints'}
                                />,
                                `Default Score: ${player.adminPoints}`,
                            )}
                        </td>
                        {this.getPlayerExposureView(player)}
                        <td>
                            <span>{player.projOwn.getValue()}</span>
                        </td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMin'}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMax'}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                    </tr>,
                );
            });
        } else {
            items.push(this.getPlayersNotFoundView({colSpan: 10}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="table-scroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th>Name</th>
                                <th>Pos</th>
                                <th className="td-team">Team</th>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>
                                    Proj
                                    <br />
                                    Own%
                                </th>
                                <th>
                                    Exp.
                                    <br />
                                    min
                                </th>
                                <th>
                                    Exp.
                                    <br />
                                    max
                                </th>
                            </tr>
                        </thead>
                        <tbody>{items}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
        playersData: {games},
    } = state;

    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
        games,
    };
}

const PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList, PlayersListComponent};
